/* eslint-disable max-len */
import React from "react";
import {addRouteComponent} from "../helpers/addRouteComponent";
import {Switch} from "react-router-dom";
import {Routes} from "../helpers/Routes";
import {StoreRoute} from "./enum";
import StoreRouteInfo from "./info";

export function getStoreComponent(routeId) {
    switch (routeId) {
        case StoreRoute.Category:
            return () => import('../../containers/StorePage/Category');
        case StoreRoute.Search:
            return () => import('../../containers/StorePage/Search');
        case StoreRoute.Orders:
            return () => import('../../containers/StorePage/Orders');
        case StoreRoute.OrderError:
            return () => import('../../containers/StorePage/Orders/OrderError');
        case StoreRoute.OrderView:
            return () => import('../../containers/StorePage/Orders/OrderDetails');
        case StoreRoute.OrderPay:
            return () => import('../../containers/StorePage/PaymentRedirect');
        case StoreRoute.Landing:
        default:
            return () => import('../../containers/StorePage/Landing');
    }
}

const routes = addRouteComponent(StoreRouteInfo, getStoreComponent);

function StoreRouter() {
    return (
        <Switch>
            { Routes(routes, routes[0].path) }
        </Switch>
    );
}

export default StoreRouter;
